import styled from 'styled-components';
import tw from 'twin.macro';

export const BackgroundContainer = styled.div`
  ${tw`laptop:flex phone:hidden laptop:flex-[0_0_55%] desktop:flex-[0_0_60%] top-0 sticky h-screen`}
`;
